<template>
  <ul class="pz_one qd_one">
    <li>
      <div class="pz_one_container">
        <ACheckbox
          :checked="formData.lastFourSign"
          @change="changeCheckboxHandle"
          >尾号签到</ACheckbox
        >

        <input
          v-model="formData.accurateField"
          type="text"
          class="txt"
          :maxLength="getMaxLength"
          :placeholder="placeholder"
        />
      </div>
    </li>
    <li>
      <a-button :loading="btnLoading" class="btnNext" @click="search"
        >查询</a-button
      >
    </li>
  </ul>
</template>

<script>
const CACHE_KEYS = {
  LAST_FOUR_SIGN: "lastFourSignState",
};

export default {
  name: "AccurateSearch",

  props: {
    btnLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formData: {
        alias: this.$route.query.alias,
        signId: this.$route.query.configuration,
        signMode: "Accurate",
        accurateField: "",
        lastFourSign: false, // 初始化时从缓存读取
      },
    };
  },

  computed: {
    placeholder() {
      return this.formData.lastFourSign
        ? "请输入手机号码后四位"
        : "Code/手机号码/身份证号码";
    },
    getMaxLength() {
      if (this.formData.lastFourSign) {
        return 4;
      }
      return null;
    },
  },

  created() {
    this.loadLastFourSignState();
  },

  methods: {
    /**
     * 从缓存加载尾号签到状态
     */
    loadLastFourSignState() {
      try {
        const cachedState = localStorage.getItem(CACHE_KEYS.LAST_FOUR_SIGN);
        if (cachedState !== null) {
          // 将字符串转换为布尔值
          this.formData.lastFourSign = cachedState === "true";
        }
      } catch (error) {
        console.warn("读取尾号签到状态缓存失败:", error);
        // 缓存读取失败时保持默认值
        this.formData.lastFourSign = false;
      }
    },

    /**
     * 保存尾号签到状态到缓存
     * @param {boolean} state - 尾号签到状态
     */
    saveLastFourSignState(state) {
      try {
        localStorage.setItem(CACHE_KEYS.LAST_FOUR_SIGN, state.toString());
      } catch (error) {
        console.warn("保存尾号签到状态到缓存失败:", error);
      }
    },

    /**
     * 清除尾号签到状态缓存（如果需要的话）
     */
    clearLastFourSignCache() {
      try {
        localStorage.removeItem(CACHE_KEYS.LAST_FOUR_SIGN);
      } catch (error) {
        console.warn("清除尾号签到状态缓存失败:", error);
      }
    },

    async search() {
      if (this.formData.accurateField === "") {
        this.$message.warning("请输入查询条件");
        return;
      }

      // 搜索前保存当前状态
      this.saveLastFourSignState(this.formData.lastFourSign);

      this.$emit("search", this.formData);
    },

    changeCheckboxHandle(e) {
      const newState = e.target.checked;
      this.formData.lastFourSign = newState;

      // 状态改变时立即保存到缓存
      this.saveLastFourSignState(newState);

      // 如果切换到尾号签到模式，清空输入框
      if (newState) {
        this.formData.accurateField = "";
      }
    },
  },
};
</script>

<style>
.pz_one_container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
